import { themr } from '@friendsofreactjs/react-css-themr';
import { compose } from 'recompose';
import intlEquipped from '../../../hocs/intlEquipped';

import CancelSubscriptionModal from './CancelSubscriptionModal';

export default compose(
    themr('CancelSubscriptionModal'),
    intlEquipped
)(CancelSubscriptionModal);
